import Embed from './Embed';
import { Body } from './Components/index';
import { DeliveryProvider } from './Providers/index';

export default Embed;
export { Body, DeliveryProvider };
